
const storage = require('./JSONStorage');


// LOAD IMAGES, TEXTURES AND SPRITES

// LOADING
/* function _setupLoading(loader, input) {
    return new Promise(resolve => {
        if (!input || typeof input !== 'string' && !(input instanceof Array)) resolve(null);

        loader.add(input);
        resolve(input);
    });
}

function _load(loader, doThat) {
    return new Promise(resolve => {
        if (!doThat) resolve(null);

        loader.load((loader, resources) => {
            resolve(resources);
        });
    });
}*/

/* ------- */

// LOADING PROGRESS
/* function _addProgressTracking(progressTracker, loader, doThat) {
    return new Promise(resolve => {
        if (!doThat) resolve(null);

        // loader.onProgress.add(progressTracker);
        loader.on('progress', progressTracker);
        resolve(doThat);
    });
}

function _removeAllProgressTracking(loader, doThat) {
    return new Promise(resolve => {
        if (!doThat) resolve(null);
        loader.onProgress.detachAll();

        resolve(doThat);
    });
}*/
/* ----- */

// LOADER RESET


/* function _reset(loader, doThat) {
    return new Promise(resolve => {
        if (!doThat) resolve(null);

        loader.reset();
        resolve(doThat);
    });
}*/
/* ----- */

// LOADING RESULT CHECKING
/* function _checkIfAtLeastOneFileLoaded(resources) {
    return new Promise(resolve => {
        if (!resources) {
            resolve(null);
            return;
        }

        for (const p in resources) {
            if (!resources.hasOwnProperty(p)) continue;
            if (!resources[p].error) {
                resolve(resources);
                return;
            }
        }
        resolve(null);
    });
}*/
/* ----- */

// TODO: load a bunch of JSONs by means of manifest

function LoadJSON(id, url, critical) {
    return new Promise((resolve, reject) => {

        fetch(url)
            .then(response => {
                if (!response.ok) throw new Error('JSON loading failed');
                return response.json();
            }, err => { throw err; })
            .then(json => {
                storage.instance().addJSON(id, json);
                resolve(json);
            }, err => { throw err; })
            .catch((/* err*/) => {
                // console.log(err);
                if (critical)
                    reject();
                resolve(null);
            });


        /* const __reset = function (loader) {
            return doThat => {
                return _reset(loader, doThat)
            };
        }(PIXI.loader);

        const __setupLoad = function (loader) {
            return input => {
                return _setupLoading(loader, input)
            };
        }(PIXI.loader);

        const __addProgressTracking = function (loader, doThat) {
            return _addProgressTracking(progressUpdate, loader, doThat);
        };

        const __trackProgress = function (loader) {
            return doThat => {
                return __addProgressTracking(loader, doThat)
            };
        }(PIXI.loader);

        const __stopAllTrackProgress = function (loader) {
            return doThat => {
                return _removeAllProgressTracking(loader, doThat)
            };
        }(PIXI.loader);

        const __load = function (loader) {
            return doThat => {
                return _load(loader, doThat)
            };
        }(PIXI.loader);

        __reset(manifest)
            .then(__setupLoad)
            .then(__trackProgress)
            .then(__load)
            .then(__stopAllTrackProgress)
            .then(_checkIfAtLeastOneFileLoaded)
            .then(resources => {
                if (resources) resolve(resources);
                else reject();
            })*/
    });
}

module.exports = LoadJSON;





// WEBPACK FOOTER //
// ./js/viscom/viscomjs/load/LoadJSON.js